import * as API from "./base";

export const index = (page) => API.get("/api/feed", { page: page || 1 });
